import Vue from 'vue';
import Vuex from 'vuex';
import { Ability } from '@casl/ability';
import storage from './storage';
import abilityPlugin from './ability';
import http from '../services/http';
import router from '../router';
import { TYPE_KEY } from '../services/utils';
import post from './post';
import language from './language';
import homepage from './homepage';
import bupage from './bupage';
import navigation from './navigation';
import csr from './csr';
import career from './career';
import about from './about';
import category from './category';
import subcategory from './subcategory';
import member from './member';
import productRegistration from './productRegistration';
import product from './product';
import productDownload from './productDownload';
import support from './support';
import pageTitle from './pageTitle';
import award from './award';
import news from './news';
import contact from './contact';
import ir from './ir';
import financial from './financial';
import shareholderFaq from './shareholderFaq';
import shareholderEvent from './shareholderEvent';
import shareholderMeeting from './shareholderMeeting';
import shareholderDividendHistory from './shareholderDividendHistory';
import shareholderEmail from './shareholderEmail';
import buyChannel from './buyChannel';
import notifications from './notifications';
import filesystem from './filesystem';
import supportFaq from './supportFaq';
import supportWarrantyPolicy from './supportWarrantyPolicy';
import QuikTip from './QuikTip';

Vue.use(Vuex);

export const store = new Vuex.Store({
  plugins: [
    storage({
      storedKeys: ['token', 'rules', 'local', 'lang', 'department'],
      destroyOn: ['DESTROY_SESSION'],
    }),
    abilityPlugin,
  ],

  modules: {
    post,
    language,
    homepage,
    bupage,
    csr,
    career,
    about,
    category,
    subcategory,
    navigation,
    filesystem,
    notifications,
    member,
    product,
    productDownload,
    support,
    pageTitle,
    buyChannel,
    award,
    news,
    contact,
    ir,
    financial,
    shareholderFaq,
    shareholderEvent,
    shareholderMeeting,
    shareholderDividendHistory,
    shareholderEmail,
    productRegistration,
    supportFaq,
    supportWarrantyPolicy,
    QuikTip,
  },

  state: {
    token: '',
    rules: [],
    local: {
      display_name: 'China',
      code: 'cn',
    },
    lang: {},
    overlay: false,
    buTabs: null,
    currentBuTabId: '',
  },

  getters: {
    isLoggedIn(state) {
      return !!state.token;
    },

    ability() {
      return new Ability([], {
        subjectName(subject) {
          return !subject || typeof subject === 'string'
            ? subject
            : subject[TYPE_KEY];
        },
      });
    },

    local(state) {
      return state.local;
    },

    lang(state) {
      return state.lang;
    },

    buTabs(state) {
      return state.buTabs;
    },

    department(state) {
      return state.department;
    },
  },

  mutations: {
    CREATE_SESSION(state, session) {
      state.token = session.token;
      state.rules = session.rules;
      state.department = session.department;
      http.token = session.token;
    },

    DESTROY_SESSION(state) {
      state.token = '';
      state.rules = [];
      state.department = '';
      state.local = {
        display_name: 'China',
        code: 'cn',
      };
      state.lang = {};
      state.buTabs = null;
      http.token = null;
    },

    SET_X_LOCALIZATION(state, value) {
      state.local = value;
    },

    SET_X_LANG(state, value) {
      state.lang = value;
    },

    SET_OVERLAY(state, value) {
      state.overlay = value;
    },

    SET_CURRENT_BU_TAB_ID(state, value) {
      state.currentBuTabId = value;
    },

    SET_BU_TABS(state, data) {
      state.buTabs = data;
    },
  },

  actions: {
    login({ commit }, data) {
      return http('/login', { method: 'POST', data }).then((response) =>
        commit('CREATE_SESSION', response.body),
      );
    },

    logout({ commit }) {
      commit('DESTROY_SESSION');
    },

    setTitle({ state }, value) {
      state.pageTitle = value;
    },

    setLocal({ commit }, value) {
      commit('SET_X_LOCALIZATION', value);
    },

    setLang({ commit }, value) {
      commit('SET_X_LANG', value);
    },

    sessionExpired({ dispatch, commit }) {
      dispatch('notifications/info', 'Session has been expired');
      commit('DESTROY_SESSION');
      router.push('/login');
    },

    forbidden({ dispatch }, response) {
      dispatch('notifications/error', response.body.message);
      router.back();
    },

    setOverlay({ commit }, value) {
      commit('SET_OVERLAY', value);
    },

    setCurrentBuTabId({ commit }, value) {
      commit('SET_CURRENT_BU_TAB_ID', value);
    },

    setBuTabs({ commit }, data) {
      commit('SET_BU_TABS', data);
    },

    upload(_, data) {
      return http('/upload', { method: 'POST', form: data }).then(
        (response) => response.body,
      );
    },

    import(_, { url, data }) {
      return http(url, { method: 'POST', form: data }).then(
        (response) => response.body,
      );
    },
  },
});
